import { render, staticRenderFns } from "./sender.vue?vue&type=template&id=1b88f329&scoped=true"
import script from "./sender.vue?vue&type=script&lang=js"
export * from "./sender.vue?vue&type=script&lang=js"
import style0 from "./sender.vue?vue&type=style&index=0&id=1b88f329&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b88f329",
  null
  
)

export default component.exports